var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 9.00023V13.0002M12.4998 17.0002H12.5098M11.1151 3.89195L2.89019 18.0986C2.43398 18.8866 2.20588 19.2806 2.23959 19.6039C2.269 19.886 2.41677 20.1423 2.64613 20.309C2.90908 20.5002 3.36435 20.5002 4.27487 20.5002H20.7246C21.6352 20.5002 22.0904 20.5002 22.3534 20.309C22.5827 20.1423 22.7305 19.886 22.7599 19.6039C22.7936 19.2806 22.5655 18.8866 22.1093 18.0986L13.8844 3.89195C13.4299 3.10679 13.2026 2.71421 12.9061 2.58235C12.6474 2.46734 12.3521 2.46734 12.0935 2.58235C11.7969 2.71421 11.5696 3.10679 11.1151 3.89195Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 9.00023V13.0002M12.4998 17.0002H12.5098M11.1151 3.89195L2.89019 18.0986C2.43398 18.8866 2.20588 19.2806 2.23959 19.6039C2.269 19.886 2.41677 20.1423 2.64613 20.309C2.90908 20.5002 3.36435 20.5002 4.27487 20.5002H20.7246C21.6352 20.5002 22.0904 20.5002 22.3534 20.309C22.5827 20.1423 22.7305 19.886 22.7599 19.6039C22.7936 19.2806 22.5655 18.8866 22.1093 18.0986L13.8844 3.89195C13.4299 3.10679 13.2026 2.71421 12.9061 2.58235C12.6474 2.46734 12.3521 2.46734 12.0935 2.58235C11.7969 2.71421 11.5696 3.10679 11.1151 3.89195Z",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 9.00023V13.0002M12.4998 17.0002H12.5098M11.1151 3.89195L2.89019 18.0986C2.43398 18.8866 2.20588 19.2806 2.23959 19.6039C2.269 19.886 2.41677 20.1423 2.64613 20.309C2.90908 20.5002 3.36435 20.5002 4.27487 20.5002H20.7246C21.6352 20.5002 22.0904 20.5002 22.3534 20.309C22.5827 20.1423 22.7305 19.886 22.7599 19.6039C22.7936 19.2806 22.5655 18.8866 22.1093 18.0986L13.8844 3.89195C13.4299 3.10679 13.2026 2.71421 12.9061 2.58235C12.6474 2.46734 12.3521 2.46734 12.0935 2.58235C11.7969 2.71421 11.5696 3.10679 11.1151 3.89195Z",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d3e0bc2a240b498480ebeb72d35212ea.svg";
export { ForwardRef as ReactComponent };